

import React from 'react';
import {Modal, ModalBody} from 'reactstrap';

import Component from '../../components/Component';
import Form from '../../components/form/Form';

export default class EditDocumentModal extends Component
{

	/**
     * The fields mapping for the form {field1: {type: 'text'}, field2: {type: 'email'}}
     *
     * @var {Object | Array[Object]}
     */
    static FormFields = {
    	name: {
			label: 'documents.edit.name_label',
			required: true,
		},
		type: {
			type: 'select',
			label: 'documents.edit.type_label',
			required: true,
			options: laravel.document_types,
		},
    };

  	render()
  	{
  		if (!this.props.document) {
  			return <div/>;
  		}

	    return (
	      	<div>
		        <Modal isOpen={this.props.isVisible}
		        	toggle={this.props.toggle}>
		          	<ModalBody>
		          		<div className="flex"
		          			style={{justifyContent: 'space-between', alignItems: 'center'}}>

							<p className="mb-0">{TB.tryTrans('documents.edit.title')}</p>

							<button type="button"
								style={{fontSize: 16, padding: 10, textAlign: 'right'}}
								className="btn"
								onClick={this.props.toggle}>
								<i className="fa fa-times-circle"/>
							</button>
						</div>

		          		<Form model={this.props.document}
		          			fields={this.constructor.FormFields}
		          			isDisabled={this.props.isDisabled}
		          			onSubmit={model => {
		          				let merged = {...this.props.document, ...model};
		          				this.props.onUpdate(merged);
		          			}}
							  submitButton={TB.tryTrans('documents.edit.submit_button')}/>
		          	</ModalBody>

		        </Modal>
	      	</div>
	    );
  	}
}